<template>
  <el-dialog
      :visible.sync="visible"
      title="确认付款"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataRule"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item prop="payDate" label="付款时间：">
            <el-date-picker type="date" v-model="dataForm.payDate" size="mini" placeholder="请选择付款时间"
                            value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="payAmount" label="付款金额：">
            <el-input v-model="dataForm.payAmount" size="mini" clearable type="text"
                      placeholder="请输入付款银行" @input="totalPayChange"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="receiverName" label="收款方：">
            <el-input v-model="dataForm.receiverName" size="mini" clearable type="text"
                      placeholder="请输入收款方"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item prop="receiverBank" label="收款行：">
            <el-input v-model="dataForm.receiverBank" size="mini" clearable type="text"
                      placeholder="请输入收款行"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16" v-if="!isPerPay">
        <el-col :span="6">
          <el-form-item prop="receiverAccount" label="收款账号：">
            <el-input v-model="dataForm.receiverAccount" size="mini" clearable type="text"
                      placeholder="请输入收款账号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="34px">
            <el-checkbox v-model="isPerPay" label="扣除预付款"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="!isPerPay">
          <el-form-item prop="payBank" label="付款银行：">
            <el-input v-model="dataForm.payBank" size="mini" clearable type="text"
                      placeholder="请输入付款银行"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="payAccount" label="付款账号：">
            <el-input v-model="dataForm.payAccount" size="mini" clearable type="text"
                      placeholder="请输入付款账号"></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="16" >
        <el-col :span="24">
        <el-form-item prop="remark" label="备注：">
          <el-input v-model="dataForm.remark" size="mini" clearable type="text"
                    placeholder="备注"></el-input>
        </el-form-item>
        </el-col>
      </el-row>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="300"
                  :summaries-column="['totalAmount','payedAmount','unPayAmount','payAmount']">
        <el-table-column prop="receiptCode" label="发票号" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="sellerName" label="付款对象" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="totalAmount" width="120" label="发票金额" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="payedAmount" width="120" label="已付款" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="unPayAmount" width="120" label="未付款" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="perPayId" label="预付款" align="center" header-align="center" v-if="isPerPay">
          <template #default="{ row, $index }">
            <el-form-item :prop="'detailList.' + $index + '.perPayId'" :rules="dataRule.perPayId" label-width="0"
                          style="margin-bottom: 0px;width: 100%;">
              <PerPayDrop v-model="row.perPayId" :company-id="row.sellerId"></PerPayDrop>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="付款金额" align="center" width="160" header-align="center">
          <template #default="{ row, $index }">
            <el-form-item :prop="'detailList.' + $index + '.amount'" :rules="dataRule.amount" label-width="0"
                          style="margin-bottom: 0px;width: 100%;">
              <el-input v-model="row.amount" size="mini" placeholder="请输入付款金额"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" header-align="center">
          <template #default="{ row,$index }">
            <el-form-item :prop="'detailList.' + $index + '.remark'" label-width="0"
                          style="margin-bottom: 0px;width: 100%;">
              <el-input v-model="row.remark" size="mini" placeholder="请输入备注"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { moneyValidator } from '@/utils/validate'
import BigNumber from 'bignumber.js'
import PerPayDrop from '@/views/modules/erp/pay/per/per-pay-drop.vue'
import is from 'moment/locale/is'

export default {
  name: 'pay-dialog',
  computed: {
    is () {
      return is
    }
  },
  components: { PerPayDrop },
  data () {
    return {
      isPerPay: false,
      dataForm: {
        payDate: '',
        payNo: '',
        payBank: '',
        payAccount: '',
        receiverBank: '',
        receiverAccount: '',
        receiverName: '',
        payAmount: '',
        remark:'',
        detailList: []
      },
      dataList: [],
      visible: false,
      dataRule: {
        amount: [
          { required: true, message: '请填写金额', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        payDate: [
          { required: true, message: '请填写付款时间' }
        ],
        payNo: [
          { required: true, message: '请填写付款凭证号' }
        ],
        perPayId: [
          { required: true, message: '请选择预付款记录' }
        ],
        receiverName: [
          { required: true, message: '请填写付款凭证号' }
        ],
      }
    }
  },
  methods: {
    totalPayChange (e) {
      let amount = new BigNumber(e)
      if (amount.isNaN()) {
        return
      }
      this.dataForm.detailList.forEach((row, index) => {
        if (amount.isLessThan(0)) {
          amount = new BigNumber(0)
          return
        }
        if (index === this.dataForm.detailList.length - 1) {
          row.amount = amount.toFixed(3)
          return
        }
        if (amount.isLessThanOrEqualTo(row.unPayAmount)) {
          row.amount = amount.toFixed(3)
        } else {
          row.amount = row.unPayAmount
        }
        amount = amount.minus(row.amount)
      })
    },
    init (detailList) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        let totalPayAmount = new BigNumber(0)
        detailList.forEach(row => {
          row.perPayId = ''
          if (row.amount < 0) {
            row.amount = 0
          } else {
            totalPayAmount = totalPayAmount.plus(row.amount)
          }
        })
        this.$set(this.dataForm, 'detailList', detailList)
        this.dataForm.payAmount = totalPayAmount.toFixed(3)
      })
    },
    dataFormSubmitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    },
    cancel () {
      this.visible = false
    },
    async doSave () {
      let postForm = this.$copy(this.dataForm)
      postForm.receiverId = postForm.detailList[0].sellerId
      for (let i = postForm.detailList.length - 1; i >= 0; i--) {
        let row = postForm.detailList[i]
        let amount = new BigNumber(row.amount)
        if (amount.isNaN() || amount.isEqualTo(0)) {
          postForm.detailList.splice(i, 1)
        }
      }
      this.$api.post(`/erp/pay/money`, postForm).then(res => {
        this.$emit('complete')
        this.$c.success('保存成功').then(() => {
          this.cancel()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
